package fr.labodoc.healthProfessional.webApp.data.repository

import arrow.core.Either
import fr.labodoc.healthProfessional.webApp.data.error.RepositoryError
import fr.labodoc.healthProfessional.webApp.data.model.MedicalProfessionModel
import fr.labodoc.healthProfessional.webApp.data.source.remote.MedicalProfessionRemoteDataSource

class MedicalProfessionsRepositoryImpl(
  private val medicalProfessionRemoteDataSource: MedicalProfessionRemoteDataSource
) : MedicalProfessionsRepository {
  override suspend fun getMedicalProfessions(
  ): Either<RepositoryError.DataSource, Set<MedicalProfessionModel>> =
    medicalProfessionRemoteDataSource
      .getMedicalProfessions()
      .mapLeft(RepositoryError::DataSource)

  override suspend fun getMedicalProfession(
    id: String
  ): Either<RepositoryError, MedicalProfessionModel> =
    medicalProfessionRemoteDataSource
      .getMedicalProfession(
        id = id
      )
      .mapLeft(RepositoryError::DataSource) // Fixme not found
}
